// @ts-nocheck
import '@fullcalendar/vue3';
import 'virtual:svg-icons-register';
import { createApp } from 'vue';
import App from './App.vue';
import directives from './general/directives';
import i18n from './general/i18n';
import router from './general/router';
import SentryService from './general/services/SentryService';
import store from './general/store';
import setupAxios from './general/utils/setupAxios';
import './shared/assets/sass/styles.scss';
import ConfigService from './shared/services/ConfigService';
import { isExpectedError } from './shared/utils/errors';

async function initApp() {
  await ConfigService.loadConfig();

  setupAxios();
  const app = createApp(App);

  SentryService.init(app, router);

  app.config.globalProperties.$config = ConfigService.config;

  app.use(i18n).use(router).use(store).use(directives);

  app.config.productionTip = false;

  const originalErrorHandler = app.config.errorHandler ?? ((error) => console.error(error)); // eslint-disable-line no-console
  app.config.errorHandler = (error, vm, info) => !isExpectedError(error) && originalErrorHandler(error, vm, info);

  // default warnHandler sometimes tries to serialize componentRefs that have not been initialized, leading to unnecessary errors
  // Vue prop type checking doesn't work properly yet when using Typescript and script setup, leading to massive warning spam
  app.config.warnHandler = (msg) => !/Invalid prop: type check failed for prop ".*"\./.test(msg) && console.warn('[VUE WARN]:', msg); // eslint-disable-line no-console

  app.mount('#app');
}

initApp();
